(function () {
  if (window.DiggnScentChooser) return;
  window.DiggnScentChooser = true;

  const chooserSelector = '[data-product-scent-chooser]';

  function getOptionContainer(root, optionPosition) {
    const picker = root.querySelector('variant-selects');
    if (!picker) return null;

    const optionContainers = Array.from(picker.children)
      .filter((child) => child.classList.contains('product-form__input'));

    return optionContainers[optionPosition - 1] || null;
  }

  function getPickerControl(optionContainer, optionValue) {
    if (!optionContainer) return null;

    const inputs = Array.from(optionContainer.querySelectorAll('input[type="radio"]'));
    const matchingInput = inputs.find((input) => input.value === optionValue);
    if (matchingInput) return matchingInput;

    const selects = Array.from(optionContainer.querySelectorAll('select'));
    return selects.find((select) =>
      Array.from(select.options).some((option) => option.value === optionValue)
    );
  }

  function getSelectedValue(optionContainer) {
    if (!optionContainer) return '';

    const checked = optionContainer.querySelector('input[type="radio"]:checked');
    const select = optionContainer.querySelector('select');
    return checked?.value || select?.value || '';
  }

  function bindChooser(chooser) {
    if (!chooser || chooser.dataset.bound === 'true') return;

    const productRoot = chooser.closest('[id^="MainProduct-"]');
    const productInfo = chooser.closest('.product__info-container');
    if (!productRoot || !productInfo) return;

    const optionPosition = Number.parseInt(chooser.dataset.optionPosition || '1', 10);
    const optionContainer = getOptionContainer(productRoot, optionPosition);
    if (!optionContainer) return;

    chooser.dataset.bound = 'true';
    chooser.hidden = false;
    productInfo.classList.add('is-scent-chooser-bound');
    optionContainer.classList.add('is-scent-chooser-managed');

    const selection = chooser.querySelector('[data-scent-selection]');

    function syncSelection(preferredDisplayName) {
      const selectedValue = getSelectedValue(optionContainer);

      chooser.querySelectorAll('[data-scent-option]').forEach((button) => {
        const isSelected = button.dataset.scentOption === selectedValue;
        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
      });

      if (selection) {
        const selectedButton = Array.from(chooser.querySelectorAll('[data-scent-option]'))
          .find((button) => button.dataset.scentOption === selectedValue);
        selection.textContent = preferredDisplayName
          || selectedButton?.dataset.scentDisplayName
          || selectedValue;
      }
    }

    chooser.addEventListener('click', (event) => {
      const button = event.target.closest('[data-scent-option]');
      if (!button || button.disabled) return;

      const control = getPickerControl(optionContainer, button.dataset.scentOption);
      if (!control) return;

      if (control.matches('input[type="radio"]')) {
        control.click();
      } else {
        control.value = button.dataset.scentOption;
        control.dispatchEvent(new Event('change', { bubbles: true }));
      }

      syncSelection(button.dataset.scentDisplayName);
      window.requestAnimationFrame(() => syncSelection(button.dataset.scentDisplayName));
    });

    productRoot.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects')) return;
      window.requestAnimationFrame(() => syncSelection());
    });

    syncSelection();
  }

  function initChoosers(root) {
    const scope = root?.querySelectorAll ? root : document;
    scope.querySelectorAll(chooserSelector).forEach(bindChooser);
  }

  initChoosers(document);
  document.addEventListener('shopify:section:load', (event) => initChoosers(event.target));

  const observer = new MutationObserver((mutations) => {
    if (!mutations.some((mutation) => mutation.addedNodes.length > 0)) return;
    initChoosers(document);
  });

  function observeDocumentBody() {
    if (!document.body) return;
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) {
    observeDocumentBody();
  } else {
    document.addEventListener('DOMContentLoaded', observeDocumentBody, { once: true });
  }
})();
